export type LogType = 'tx' | 'rx' | 'system' | 'error' | 'warn';

export interface LogEntry {
  timestamp: Date;
  type: LogType;
  message: string;
}

export type LogListener = (entry: LogEntry) => void;

export class Logger {
  private entries: LogEntry[] = [];
  private listeners: Set<LogListener> = new Set();
  private readonly maxEntries = 1000;

  log(message: string, type: LogType = 'system'): void {
    const entry: LogEntry = {
      timestamp: new Date(),
      type,
      message,
    };

    this.entries.push(entry);
    if (this.entries.length > this.maxEntries) {
      this.entries.shift();
    }

    this.listeners.forEach((cb) => cb(entry));
  }

  subscribe(callback: LogListener): () => void {
    this.listeners.add(callback);
    return () => this.listeners.delete(callback);
  }

  getEntries(): LogEntry[] {
    return [...this.entries];
  }

  clear(): void {
    this.entries = [];
  }
}
